import SuperAdminDashboard from "../superadmin/Dashboard";
import CustomerDetailsPage from "../superadmin/CustomerDetailsPage";
import CustomerAccessControlPage from "../superadmin/CustomerAccessControlPage";
import UnderConstructionPage from "../components/CommonComponents/UnderConstructionIcon";
import ProtectedRoute from "./ProtectedRoute";
import { ThemeProvider } from "../components/CommonComponents/ThemeProvider";

export const superadminRoutes = [
    {
        path: "/superadmin/dashboard",
        element: <ProtectedRoute allowedRoles={[0]}><SuperAdminDashboard /></ProtectedRoute>,
    },
    {
        path: "/superadmin/customer-details",
        element: <ProtectedRoute allowedRoles={[0]}><CustomerDetailsPage /></ProtectedRoute>,
    },
    {
        path: "/superadmin/customer-access-control",
        element: <ProtectedRoute allowedRoles={[0]}><CustomerAccessControlPage /></ProtectedRoute>,
    },
    {
        path: "/superadmin/settings",
        element: <ProtectedRoute allowedRoles={[0]}><UnderConstructionPage /></ProtectedRoute>,
    },
    {
        path: "/superadmin/appearance",
        element: <ProtectedRoute allowedRoles={[0]}><ThemeProvider /></ProtectedRoute>,
    },
];
